import styled from "styled-components";
import { Space, Button as AntButton } from "antd";

export const RootContainer = styled.div`
  padding: 16px;

  .ant-form {
    margin-top: 22px;
    min-height: calc(100vh - 440px);
    position: relative;

    @media screen and (max-width: 375px) {
      min-height: calc(100vh - 398px);
    }

    @media screen and (max-width: 325px) {
      min-height: calc(100vh - 389px);
    }
  }

  .ant-input {
    padding-left: 20px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #181E1F;
  }

  .float-label label {
    color: #C21C05;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const InfoBox = styled(Space).attrs({
  direction: "vertical",
})`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 50px;
  margin-bottom: 6px;
`;

export const Text = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #101415;

  @media screen and (max-width: 345px) {
    font-size: 13px;
  }

  @media screen and (max-width: 320px) {
    font-size: 12px;
  }
`;

export const BoldText = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #71207c;
`;

export const GroupContainer = styled.div`
  margin: 16px 0;

  @media screen and (max-width: 325px) {
    .ant-col {
      padding-left: 3px !important;
      padding-right: 3px !important;
    }
  }
`;

export const Item = styled.div`
padding: 12px;
border-radius: 8px;
border: 1px solid #E6E6E6;
background: ${props => props.selected === 'true' ? '#C21C05' : '#F7F7F7'};
cursor: pointer;
display: flex;
align-items: center;

${Text} {
  flex: 1;
  color: ${props => props.selected === 'true' ? '#F7F7F7' : '#101415'};
}


@media screen and (max-width: 375px) {
  padding: 8px;
  
  ${Text} {
    font-size: 12px;
  }
}

@media screen and (max-width: 325px) {
  padding: 8px;

  ${Text} {
    font-size: 10px;
  }
}
`;

export const HelperText = styled.div`
  padding-top: 6px;
  padding-left: 20px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #808080;

  @media screen and (max-width: 345px) {
    font-size: 11px;
  }

  @media screen and (max-width: 320px) {
    font-size: 10px;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;

  .ant-btn {
    height: 52px;
    margin-top: 24px;
  }
`;

export const Box = styled(Space).attrs({
  size: "middle",
})`
  margin-right: -36px;
  align-items: center;

  .anticon {
    font-size: 20px;
    cursor: pointer;
  }
`;

export const ContinueButton = styled(AntButton)`
  color: ${props => (props.amount? `#6D1304 !important` : "#FFF !important")};

`